import { Badge, ButtonLink, Header } from '@asgard/ui-library';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import * as SP from '../../HrAsAServicePage.styled';
import * as S from './Evaluate.styled';

export const Evaluate: React.FC = () => {
  const { t } = useI18n('hr-as-a-service');

  return (
    <S.Root>
      <SP.Container>
        <S.Intro>
          <Badge
            bold
            schema="neutral"
            label={t('hr-as-a-service.evaluate.badge')}
            variant="white"
          />
          <Header as="h3" size="5xl" editorial>
            <HtmlTrans
              ns="hr-as-a-service"
              i18nKey={'hr-as-a-service.evaluate.title'}
            />
          </Header>

          <HtmlTrans
            ns="hr-as-a-service"
            i18nKey={'hr-as-a-service.evaluate.desc'}
          />

          <ButtonLink
            variant="hard"
            schema="brand2"
            startIcon={faCheckCircle}
            label={t('hr-as-a-service.evaluate.cta')}
            href="https://getmanfred.typeform.com/to/ghpHTBB1"
            target="_blank"
          />
        </S.Intro>
      </SP.Container>
    </S.Root>
  );
};
